// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"icon_iconWrapper__2xUl0"};